module.exports = __webpack_public_path__ + "img/ux.f25c4926.gif";